<ion-content class="sos-content" scroll-y="false">
  <div class="sos-icon-wrapper">
    <ion-icon name="alert" class="sos-icon"></ion-icon>
  </div>

  <h2 class="sos-title">Le bouton SOS a été activé</h2>

  <p class="sos-subtitle">Envoi automatique du SOS à la fin du chronomètre</p>

  <div class="timer-wrapper" (click)="stopAndCloseModal()">
    <countdown-timer #timer [durationInSeconds]="30" (done)="onCountdownDone()"></countdown-timer>
  </div>

  <p class="cancel-text">Cliquez sur le chronomètre pour stopper l’envoi</p>
</ion-content>

<ion-footer>
  <ion-button class="sos-send-btn" expand="block" color="danger" [disabled]="disableButton()" (click)="sendSOS()">
    Envoyer l'alerte immédiatement
  </ion-button>
</ion-footer>
